import AdminMenuId from "../utils/constants/AdminMenuId";
import UserMenuId from "../utils/constants/UserMenuId";

let NavMenu = (props) => {
    let onClick = (_) => {
        props.onMenuChange(props.menuid)
    }
    let getMenuText = () => {
        return props.isAdmin ? AdminMenuId.text[props.menuid] : UserMenuId.text[props.menuid]
    }
    return (<div className={props.currentMenu === props.menuid ?
        "navbar-menu navbar-menu-current" : "navbar-menu"}
                 onClick={onClick.bind(this)}>
        {props.currentMenu === props.menuid ?
            <p className="current">
                {getMenuText()}</p> :
            <p>{getMenuText()}</p>}
    </div>)
}
export default NavMenu;